import type { SmePackage } from '@/types';
import { smePackages } from '../pages/create-campaign/data';

// export function getPackageByBudget(budget: number): SmePackage | null {
//   // Filter packages that are >= budget and sort by price ascending
//   const eligiblePackages = smePackages.filter(pkg => pkg.price >= budget).sort((a, b) => a.price - b.price);

//   // Return the first one (lowest price that meets criteria) or null if none found
//   return eligiblePackages.length > 0 ? eligiblePackages[0] : null;
// }

export function getPackageByBudget(budget: number): SmePackage | null {
  // Filter packages that the budget can afford
  const affordablePackages = smePackages.filter(pkg => budget >= pkg.price).sort((a, b) => b.price - a.price);

  if (affordablePackages.length > 0) {
    return affordablePackages[0]; // Most expensive they can afford
  }

  // If they can't afford any package, return the cheapest one
  return smePackages.sort((a, b) => a.price - b.price)[0];
}

export const packagesCreatorBreakdown = [
  {
    package: 'Launch',
    nanoCount: 6,
    microCount: 2,
  },
  {
    package: 'Boost',
    nanoCount: 9,
    microCount: 3,
  },
  {
    package: 'Scale',
    nanoCount: 12,
    microCount: 6,
  },
  {
    package: 'Platinum',
    nanoCount: 15,
    microCount: 15,
  },
];

export const getPackageCreatorBreakdown = (budgetPackage: string) => {
  const selectedPacakge = packagesCreatorBreakdown.find(breakdown => breakdown.package === budgetPackage);
  return selectedPacakge;
};
